<mdc-dialog>
  <mdc-dialog-container>
    <mdc-dialog-surface>
      <mdc-dialog-title>Åpne kasse</mdc-dialog-title>
      <mdc-dialog-content>
        <p>{{text}}</p>
        <app-kasse-start-stopp
          [kassedata]="minkasse"
          [admin]=true
          (startet)="startSalg()"
          (stoppet)="stoppSalg()">
        </app-kasse-start-stopp>
      </mdc-dialog-content>
      <mdc-dialog-actions>
        <button mdcDialogButton class="button-no-bg" mdcDialogAction="close">Avbryt</button>
      </mdc-dialog-actions>
    </mdc-dialog-surface>
  </mdc-dialog-container>
</mdc-dialog>
